module.exports = __webpack_public_path__ + "img/er_wei_ma.57bf7dab.jpg";